module.exports = __webpack_public_path__ + "img/aod-w.svg";